export const styleNavOpen = {
	marginLeft: "130px",
};
export const styleNavClosed = {
	marginLeft: "20px",
};
